var _circle, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPeople = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 120 120"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 60,
  cy: 60,
  r: 60,
  fill: "#F6F9FC"
})), /*#__PURE__*/React.createElement("mask", {
  id: "people_svg__a",
  width: 118,
  height: 119,
  x: 1,
  y: 2,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#F6F9FC",
  d: "M118.742 61.167c0 32.493-26.357 58.834-58.87 58.834C27.358 120.001 1 93.661 1 61.167c0-20.415 16.587-58.833 58.87-58.833 32.523 0 58.871 26.34 58.871 58.833Z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#people_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#C0D8F0",
  d: "M86.035 55.91c1.701.132 3.437.196 5.207.194h.988a15.757 15.757 0 0 0 1.2-8.05 9.508 9.508 0 0 0-2.188-.257c-5.624 0-10.18 4.871-10.18 12.167-.004 1.369.11 2.736.341 4.086v-.028a19.718 19.718 0 0 0 4.632-8.113Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C5CFD9",
  d: "M44.956 54.461c0 .794-.014 1.587-.04 2.38a15.852 15.852 0 0 0 13.625-4.517 15.834 15.834 0 0 0 4.382-13.663 13.344 13.344 0 0 0-3.314-.425c-7.481.004-14.653 6.494-14.653 16.225Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C0D8F0",
  d: "M19.553 59.972a15.854 15.854 0 0 0 14.686-9.838 9.321 9.321 0 0 0-6.216-2.36c-5.608 0-10.152 4.84-10.18 12.099.568.064 1.139.097 1.71.099Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C5CFD9",
  d: "M78.454 84.916c2.018 2.046 3.381 4.571 3.381 7.667v25.259h1.487c.803 0 1.572-.386 2.14-1.075.567-.688.886-1.622.886-2.596V79.547c-.506.755-5.155 2.181-7.894 5.37Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C0D8F0",
  d: "M37.443 122.269V90.955c0-7.836 12.169-10.58 13.093-11.793v38.958a4.195 4.195 0 0 1-1.176 2.922 3.958 3.958 0 0 1-2.84 1.21l-9.077.017Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#C5CFD9",
  d: "M11.338 110.871V88.057c0-5.708 9.129-7.712 9.835-8.592v28.395a3.012 3.012 0 0 1-3.012 3.011h-6.823Z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#36485C",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.925,
  d: "M64.174 78.689c5.461 1.19 17.634 4.601 17.634 12.214v30.434M54.997 78.689c-5.462 1.19-17.635 4.601-17.635 12.214v30.434"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#36485C",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.925,
  d: "M54.997 73.428v5.26c-1.893.508-4.517 1.325-4.517 2.245 0 1.543 4.847 5.59 9.105 5.59 4.26 0 9.105-4.047 9.105-5.59 0-.92-2.623-1.737-4.516-2.245v-5.2M24.523 79.518c-4.096.88-13.225 3.45-13.225 9.16v22.115M31.42 79.518c2.56.551 7.086 1.76 10.122 3.967"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#36485C",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.925,
  d: "M31.421 75.57v3.967c1.417.397 3.39.992 3.39 1.682 0 1.159-3.64 4.193-6.83 4.193-3.192 0-6.832-3.034-6.832-4.193 0-.69 1.985-1.3 3.39-1.682v-3.9"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#36485C",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.925,
  d: "M27.965 76.312c-3.687 0-10.185-4.978-10.185-15.626 0-7.299 4.56-12.166 10.185-12.166 5.624 0 10.18 4.867 10.18 12.166 0 10.667-6.326 15.626-10.18 15.626ZM94.647 79.518c4.096.88 13.225 3.45 13.225 9.16v22.115M87.781 79.518c-2.56.551-7.085 1.76-10.12 3.967"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#36485C",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.925,
  d: "M87.78 75.57v3.967c-1.42.397-3.39.992-3.39 1.682 0 1.159 3.64 4.193 6.831 4.193 3.191 0 6.831-3.034 6.831-4.193 0-.69-1.985-1.3-3.39-1.682v-3.9"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#36485C",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.925,
  d: "M91.206 76.312c3.687 0 10.184-4.978 10.184-15.626 0-7.299-4.56-12.166-10.184-12.166s-10.173 4.867-10.173 12.166c0 10.667 6.31 15.626 10.173 15.626ZM60.693 49.48a13.592 13.592 0 0 1-15.245 8.01M31.873 54.87a13.625 13.625 0 0 0 5.858 6.566M55.235 73.143a7.874 7.874 0 0 0 4.366 1.587c3.934 0 10.86-5.308 10.86-16.662"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#36485C",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.925,
  d: "M48.722 58.052c0 7.81 3.175 12.758 6.517 15.074"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#36485C",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.925,
  d: "M67.141 74.717c3.26.004 6.496-.542 9.574-1.615a65.743 65.743 0 0 1-2.469-17.899c0-9.73-7.144-16.22-14.65-16.22-7.505 0-14.681 6.49-14.681 16.22a65.597 65.597 0 0 1-2.469 17.9 28.988 28.988 0 0 0 9.574 1.614M17.926 60.365a13.584 13.584 0 0 0 13.963-5.494M81.383 64.757a19.694 19.694 0 0 0 4.616-8.081c1.701.127 3.437.191 5.207.194 1.77.003 3.506-.062 5.207-.194a19.783 19.783 0 0 0 4.616 8.084"
}))));
export default SvgPeople;